import { actions } from "@ehi/global-marketing-interface";

export const clearBillingAccount = () => (dispatch) => {
    dispatch(actions.reservations.commitState.unset('billing_account'));
    dispatch(actions.reservations.commitState.unset('billing_account_type'));
};